module.exports = __webpack_public_path__ + "static/img/headpic.70086d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headpic.png
// module id = yU0A
// module chunks = 1